import React from "react";
import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { SupplierPartForDelivery } from "../../types";

interface PartsListColumnProps {
  parts: SupplierPartForDelivery[];
}

export const PartsListColumn: React.FC<PartsListColumnProps> = ({ parts }) => (
  <Box
    flex="1"
    px={4}
    py={3}
    borderRight={{ base: "none", md: "1px solid" }}
    borderBottom={{ base: "1px solid", md: "none" }}
    borderColor="gray.100"
    bg="gray.50"
  >
    <HStack mb={2} spacing={4}>
      <Text
        fontSize="0.7rem"
        color="gray.500"
        fontFamily="'Nunito','Inter', sans-serif"
        fontWeight="700"
        textTransform="uppercase"
        flex="1"
      >
        Part Details
      </Text>
      <Text
        fontSize="0.7rem"
        color="gray.500"
        fontFamily="'Nunito','Inter', sans-serif"
        fontWeight="700"
        textTransform="uppercase"
        w="40px"
        textAlign="right"
      >
        Qty
      </Text>
    </HStack>

    <Box
      maxH="180px"
      overflowY="auto"
      pr={1}
      css={{
        "&::-webkit-scrollbar": { width: "4px" },
        "&::-webkit-scrollbar-track": { background: "transparent" },
        "&::-webkit-scrollbar-thumb": {
          background: "#CBD5E0",
          borderRadius: "2px",
        },
      }}
    >
      <VStack align="stretch" spacing={2}>
        {parts.map((part, index) => (
          <HStack
            key={`${part.partNumber}-${index}`}
            spacing={4}
            pb={1}
            borderBottom="1px dashed"
            borderColor="gray.200"
            _last={{ borderBottom: "none" }}
          >
            <VStack align="start" spacing={0} flex="1">
              <Text
                fontSize="0.8rem"
                color="gray.700"
                fontFamily="'Nunito','Inter', sans-serif"
                fontWeight="700"
                lineHeight="1"
              >
                {part.partNumber}
              </Text>
              <Text
                fontSize="0.8rem"
                color="gray.600"
                fontFamily="'Nunito','Inter', sans-serif"
                fontWeight="500"
                mt="1"
                lineHeight="1.1"
                wordBreak="break-all"
              >
                {part.partName}
              </Text>
            </VStack>
            <Text
              fontSize="0.8rem"
              color="gray.700"
              fontFamily="'Nunito','Inter', sans-serif"
              textAlign="right"
              fontWeight="600"
            >
              {part.quantity}
            </Text>
          </HStack>
        ))}
      </VStack>
    </Box>
  </Box>
);
